export default __webpack_public_path__ + "static/media/pipe-icon.b592c75e.svg";